import React, {Component} from "react";
import "./InquiriesPerUserTable.css"
import InquiriesPerUserHeader from "../InquiriesPerUserHeader/InquiriesPerUserHeader";
import InquiriesPerUserBottom from "../InquiriesPerUserBottom/InquiriesPerUserBottom";
import InquiriesPerUserRow from "../InquiriesPerUserRow/InquiriesPerUserRow";
import {RESOURCE_BASE_URL, ITEM_COUNT_PER_PAGE} from "../../../../configuration";
import axios from "axios";
import {FormattedMessage} from "react-intl";
import { Link } from 'react-router-dom';

class InquiriesPerUserTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inquiries: [],
            totalItemCount: 0,
            activePage: 1,

        };

        this.getAllInquiries = this.getAllInquiries.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.searchCustomerInquiries = this.searchCustomerInquiries.bind(this);
    }

    componentDidMount() {
        this.getAllInquiries(0, ITEM_COUNT_PER_PAGE);
    }

    handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);

        this.setState({activePage: pageNumber});

        let offset = (pageNumber - 1);
        this.getAllInquiries(offset, ITEM_COUNT_PER_PAGE);
    };

    getAllInquiries = (offset, limit) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/inquiries?offset=' + offset + '&limit=' + limit, axiosConfig)
            .then((res) => {
                // console.log("=====userId =======================  ",this.props.userId)
                // console.log("=====inquiry =======================  ",res.data.inquiries)
                this.setState({
                    inquiries: res.data.inquiries.content,
                    totalItemCount: res.data.rowCount
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    searchCustomerInquiries = (offset,limit) => {

    };

    render() {
        let no = 1 + ((this.state.activePage - 1) * ITEM_COUNT_PER_PAGE);
        return (
            <div>
                <div className="admin-user-address-list-scroll customer-order-height-responsive">
                    <div className="admin-tables">

                        <div className="admin-table-row-content">
                        <table className="table table-bordered customers-table-resp">
                            <InquiriesPerUserHeader/>
                            <tbody>
                            {
                                this.state.inquiries.length !== 0 ?
                                this.state.inquiries.map(inquiry => {
                                return <InquiriesPerUserRow key={inquiry.id} getAll={this.props.getAll} inquiry={inquiry}
                                                            no={no++}/>
                            }) :
                                    <tr>
                                        <td colSpan={5}>
                                        <div className="text-center">
                                            利用可能な記録はありません。
                                        </div>
                                    </td>
                                    </tr>
                            }

                            </tbody>
                        </table>

                        </div>

                    </div>
                </div>
                <InquiriesPerUserBottom activePage={this.state.activePage}
                                        itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                        totalItemsCount={this.state.totalItemCount}
                                        handlePageChange={this.handlePageChange}/>
                <div className="pull-right resp-back-btn-ipu">
                    <Link to={"/admin/customers/all"} className="">
                        <FormattedMessage id="app.admin-info.back"
                                          defaultMessage="<< Back"
                                          description=""/>
                    </Link>
                </div>
            </div>
        )
    }
}

export default InquiriesPerUserTable;



// WEBPACK FOOTER //
// ./src/components/Admin/InquiriesPerUser/InquiriesPerUserTable/InquiriesPerUserTable.js